module.exports = __webpack_public_path__ + "static/dev_2-b493002daa884c9bc5c3bcf9fa52053c.png";